<template>
  <div class="career-detail">
    <!-- 顶部标题区域 -->
    <section class="products-header">
      <div class="container">
        <h1 class="page-title">
          <span class="title-glow">岗位详情</span>
        </h1>
        <p class="page-subtitle">了解更多岗位信息，看看这里是否适合你</p>
      </div>
    </section>

    <!-- 主内容区域 -->
    <section class="detail-main">
      <div class="container">
        <!-- 返回按钮 -->
        <div class="back-button">
          <button @click="goBack" class="btn-back">
            <span>←</span> 返回招聘列表
          </button>
        </div>

        <!-- 加载状态 -->
        <div v-if="loading" class="detail-loading">
          <div class="loading-spinner"></div>
          <p>加载中...</p>
        </div>

        <!-- 错误提示 -->
        <div v-else-if="error" class="detail-error">
          <p>{{ error }}</p>
          <p class="error-hint">请返回招聘列表重试，或联系管理员检查职位配置</p>
        </div>

        <!-- 岗位详情 -->
        <div v-else-if="job" class="detail-card">
          <div class="detail-header">
            <h2 class="detail-title">{{ job.title }}</h2>
            <div class="detail-meta">
              <span class="detail-item">工作性质：{{ job.workType || '—' }}</span>
              <span class="detail-item">薪资范围：{{ job.salaryRange || '—' }}</span>
              <span class="detail-item">招聘人数：{{ job.recruitCount || '—' }}</span>
              <span class="detail-item">工作地点：{{ job.location || '—' }}</span>
            </div>
          </div>

          <!-- 岗位职责 -->
          <div v-if="job.responsibilities && job.responsibilities.length > 0" class="detail-section">
            <h3 class="section-title">岗位职责</h3>
            <ul class="section-list">
              <li v-for="(resp, index) in job.responsibilities" :key="index">
                {{ resp }}
              </li>
            </ul>
          </div>

          <!-- 任职要求 -->
          <div v-if="job.requirements" class="detail-section">
            <h3 class="section-title">任职要求</h3>
            
            <div v-if="job.requirements.education" class="requirement-item">
              <h4 class="requirement-label">教育背景：</h4>
              <p class="requirement-content">{{ job.requirements.education }}</p>
            </div>

            <div v-if="job.requirements.experience" class="requirement-item">
              <h4 class="requirement-label">经验要求：</h4>
              <p class="requirement-content">{{ job.requirements.experience }}</p>
            </div>

            <div v-if="job.requirements.skills && job.requirements.skills.length > 0" class="requirement-item">
              <h4 class="requirement-label">专业技能：</h4>
              <ul class="section-list">
                <li v-for="(skill, index) in job.requirements.skills" :key="index">
                  {{ skill }}
                </li>
              </ul>
            </div>

            <div v-if="job.requirements.qualities && job.requirements.qualities.length > 0" class="requirement-item">
              <h4 class="requirement-label">综合素质：</h4>
              <ul class="section-list">
                <li v-for="(quality, index) in job.requirements.qualities" :key="index">
                  {{ quality }}
                </li>
              </ul>
            </div>

            <div v-if="job.requirements.preferred && job.requirements.preferred.length > 0" class="requirement-item">
              <h4 class="requirement-label">优先条件：</h4>
              <ul class="section-list">
                <li v-for="(pref, index) in job.requirements.preferred" :key="index">
                  {{ pref }}
                </li>
              </ul>
            </div>
          </div>

          <div class="detail-section apply-section">
            <h3 class="section-title">投递方式</h3>
            <p class="apply-text">
              请将<b>个人简历</b>发送至：
              <a v-if="job.email" :href="`mailto:${job.email}?subject=${encodeURIComponent(job.emailSubject || (job.title + '-应聘'))}`">
                {{ job.email }}
              </a>
              <span v-else>请联系公司人力资源邮箱</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'CareersDetail',
  data() {
    return {
      job: null,
      loading: false,
      error: null
    }
  },
  async mounted() {
    const id = this.$route.query.id
    if (id == null) {
      this.error = '缺少岗位 ID 参数'
      return
    }
    await this.fetchJobDetail(id)
  },
  methods: {
    async fetchJobDetail(id) {
      try {
        this.loading = true
        this.error = null
        // 从详情 API 获取完整岗位信息
        const response = await axios.get(`/api/about/careerstable/detail/${id}`)
        if (response.data.code === 200) {
          this.job = response.data.data
        } else {
          this.error = response.data.message || '获取岗位详情失败'
          this.job = null
        }
      } catch (e) {
        console.error('获取岗位详情失败:', e)
        if (e.response && e.response.status === 404) {
          this.error = '未找到对应的岗位信息'
        } else {
          this.error = '网络请求失败，请检查服务器是否运行'
        }
        this.job = null
      } finally {
        this.loading = false
      }
    },
    goBack() {
      this.$router.push('/about/careers')
    }
  }
}
</script>

<style scoped>
.career-detail {
  min-height: 100vh;
  background: #f5f7fa;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 顶部标题区域 */
.products-header {
  position: relative;
  background-image: url('@/assets/background_header/加入我们详情页.png');
  background-size: cover;
  background-position: center;
  padding: 45px 0;
  overflow: hidden;
  min-height: 200px;
  display: flex;
  align-items: center;
}

.products-header .container {
  position: relative;
  z-index: 2;
  width: 100%;
  margin: 0;
  padding: 0 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
}

.page-title {
  margin: 0;
}

.title-glow {
  display: inline-block;
  font-size: 46px;
  font-weight: 900;
  letter-spacing: 5px;
  color: #ffffff;
  font-family: 'Arial Black', 'Microsoft YaHei', sans-serif;
  filter: drop-shadow(0 0 10px rgba(96, 165, 250, 0.6));
  backdrop-filter: blur(5px);
}

.page-subtitle {
  margin: 8px 0 0 0;
  text-align: left;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-style: italic;
  line-height: 1.8;
  opacity: 1;
  max-width: 900px;
  margin-left: 2em;
  position: relative;
  z-index: 2;
  backdrop-filter: blur(5px);
}

/* 主内容区域 */
.detail-main {
  background: #f5f7fa;
  padding: 40px 0 80px 0;
}

/* 返回按钮 */
.back-button {
  margin-bottom: 30px;
}

.btn-back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  font-size: 14px;
  color: #4c95e3;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-back:hover {
  color: white;
  background: #4c95e3;
  border-color: #4c95e3;
}

.btn-back span {
  font-size: 18px;
}

/* 详情卡片 */
.detail-card {
  background: white;
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.detail-header {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #f0f0f0;
}

.detail-title {
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
}

.detail-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  font-size: 14px;
  color: #666;
}

.detail-item {
  display: inline-flex;
  align-items: center;
}

.detail-location::before {
  content: '📍';
  margin-right: 4px;
}

.detail-type::before {
  content: '💼';
  margin-right: 4px;
}

.detail-section {
  margin-top: 24px;
}

.section-title {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 12px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid #4c95e3;
  display: inline-block;
}

.section-list {
  margin: 12px 0 0 0;
  padding-left: 22px;
  font-size: 15px;
  line-height: 1.8;
  color: #333;
}

.section-list li {
  margin-bottom: 8px;
}

.requirement-item {
  margin-bottom: 20px;
}

.requirement-item:last-child {
  margin-bottom: 0;
}

.requirement-label {
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 8px 0;
}

.requirement-content {
  font-size: 15px;
  line-height: 1.8;
  color: #333;
  margin: 0;
  padding-left: 0;
}

.apply-section {
  margin-top: 28px;
}

.apply-text {
  font-size: 15px;
  color: #333;
}

.apply-text a {
  color: #4c95e3;
  text-decoration: none;
}

.apply-text a:hover {
  text-decoration: underline;
}

/* 加载和错误状态 */
.detail-loading,
.detail-error {
  text-align: center;
  padding: 60px 20px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto 20px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #4c95e3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.detail-loading p {
  color: #666;
  font-size: 16px;
}

.detail-error {
  background: #ffecec;
  border-radius: 8px;
  padding: 30px;
}

.detail-error p {
  color: #c0392b;
  margin: 0 0 10px 0;
  font-size: 16px;
}

.error-hint {
  color: #999 !important;
  font-size: 14px !important;
}

/* 响应式 */
@media (max-width: 768px) {
  .products-header {
    padding: 50px 0;
    min-height: 190px;
  }

  .title-glow {
    font-size: 32px;
    letter-spacing: 1.5px;
  }

  .products-header .container {
    padding: 0 24px;
  }

  .page-subtitle {
    margin-left: 1.5em;
    font-size: 14px;
  }

  .detail-main {
    padding: 30px 0 60px 0;
  }

  .detail-card {
    padding: 24px 16px;
  }

  .detail-title {
    font-size: 22px;
  }
}

@media (max-width: 480px) {
  .title-glow {
    font-size: 28px;
    letter-spacing: 1px;
  }

  .detail-card {
    padding: 20px 12px;
  }
}
</style>


